import { z } from "zod";

/**
 * Runtime configuration fetched from /config.json at startup. The file is
 * generated at build time from env vars (see scripts/app-config.mjs), with
 * placeholder fallbacks so the bundle always builds; a real deployment
 * supplies the Auth0 values. apiBase is "" (same-origin) in production.
 */
export const appConfigSchema = z.object({
  auth0Domain: z.string(),
  auth0ClientId: z.string(),
  auth0Audience: z.string(),
  /** API origin; web is same-origin so "" is the default. */
  apiBase: z.string(),
});

export type AppConfig = z.infer<typeof appConfigSchema>;

export async function loadConfig(): Promise<AppConfig> {
  const res = await fetch("/config.json", { cache: "no-store" });
  if (!res.ok) {
    throw new Error(`failed to load /config.json: ${res.status}`);
  }
  return appConfigSchema.parse(await res.json());
}
